// Shared positioning logic for tooltips and popovers
// Generates same HTML structure as Bootstrap 3 for CSS compatibility

// Calculate element position relative to document
function getElementPosition(el) {
  const rect = el.getBoundingClientRect()
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft

  return {
    top: rect.top + scrollTop,
    left: rect.left + scrollLeft,
    width: rect.width,
    height: rect.height,
    // Viewport-relative for boundary checks
    viewportTop: rect.top,
    viewportLeft: rect.left,
    viewportBottom: rect.bottom,
    viewportRight: rect.right
  }
}

// Get viewport dimensions
function getViewport() {
  return {
    width: window.innerWidth,
    height: window.innerHeight
  }
}

// Check if placement fits in viewport, return flipped placement if not
function getAdjustedPlacement(placement, triggerPos, tipWidth, tipHeight) {
  const viewport = getViewport()
  const margin = 10 // Minimum margin from viewport edge

  switch (placement) {
    case 'top':
      if (triggerPos.viewportTop - tipHeight < margin) {
        return 'bottom'
      }
      break
    case 'bottom':
      if (triggerPos.viewportBottom + tipHeight > viewport.height - margin) {
        return 'top'
      }
      break
    case 'left':
      if (triggerPos.viewportLeft - tipWidth < margin) {
        return 'right'
      }
      break
    case 'right':
      if (triggerPos.viewportRight + tipWidth > viewport.width - margin) {
        return 'left'
      }
      break
  }

  return placement
}

// Calculate tooltip/popover position based on placement
function calculatePosition(placement, triggerPos, tipWidth, tipHeight) {
  let top, left

  switch (placement) {
    case 'top':
      top = triggerPos.top - tipHeight
      left = triggerPos.left + (triggerPos.width / 2) - (tipWidth / 2)
      break
    case 'bottom':
      top = triggerPos.top + triggerPos.height
      left = triggerPos.left + (triggerPos.width / 2) - (tipWidth / 2)
      break
    case 'left':
      top = triggerPos.top + (triggerPos.height / 2) - (tipHeight / 2)
      left = triggerPos.left - tipWidth
      break
    case 'right':
      top = triggerPos.top + (triggerPos.height / 2) - (tipHeight / 2)
      left = triggerPos.left + triggerPos.width
      break
  }

  return { top, left }
}

// Adjust position to stay within viewport and calculate arrow offset
function adjustForViewport(placement, position, tipWidth, tipHeight) {
  const viewport = getViewport()
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  const margin = 10
  let arrowOffset = null // null means centered (default)
  let shift

  // Convert to viewport coordinates for checking
  const viewportLeft = position.left - scrollLeft
  const viewportTop = position.top - scrollTop

  if (placement === 'top' || placement === 'bottom') {
    // Horizontal adjustment
    if (viewportLeft < margin) {
      shift = margin - viewportLeft
      position.left += shift
      // Arrow needs to shift left (as percentage from center)
      arrowOffset = 50 - (shift / tipWidth * 100)
    } else if (viewportLeft + tipWidth > viewport.width - margin) {
      shift = (viewportLeft + tipWidth) - (viewport.width - margin)
      position.left -= shift
      // Arrow needs to shift right (as percentage from center)
      arrowOffset = 50 + (shift / tipWidth * 100)
    }
  } else {
    // Vertical adjustment for left/right placement
    if (viewportTop < margin) {
      shift = margin - viewportTop
      position.top += shift
      arrowOffset = 50 - (shift / tipHeight * 100)
    } else if (viewportTop + tipHeight > viewport.height - margin) {
      shift = (viewportTop + tipHeight) - (viewport.height - margin)
      position.top -= shift
      arrowOffset = 50 + (shift / tipHeight * 100)
    }
  }

  // Clamp arrow offset to reasonable bounds
  if (arrowOffset !== null) {
    arrowOffset = Math.max(10, Math.min(90, arrowOffset))
  }

  return {
    top: Math.round(position.top),
    left: Math.round(position.left),
    arrowOffset
  }
}

// Main positioning function
function position(triggerEl, tipEl, placement) {
  const triggerPos = getElementPosition(triggerEl)

  // Temporarily show to measure
  tipEl.style.display = 'block'
  tipEl.style.visibility = 'hidden'
  const tipWidth = tipEl.offsetWidth
  const tipHeight = tipEl.offsetHeight
  tipEl.style.visibility = ''

  // Check if placement fits, flip if needed
  const adjustedPlacement = getAdjustedPlacement(placement, triggerPos, tipWidth, tipHeight)

  // Calculate base position
  const pos = calculatePosition(adjustedPlacement, triggerPos, tipWidth, tipHeight)

  // Adjust for viewport boundaries
  const adjusted = adjustForViewport(adjustedPlacement, pos, tipWidth, tipHeight)

  return {
    placement: adjustedPlacement,
    top: adjusted.top,
    left: adjusted.left,
    arrowOffset: adjusted.arrowOffset
  }
}

const PopoverPosition = {
  position: position
}

export default PopoverPosition
